export default class EnumFormatter {
  format(text: string): string {
    if (!text) {
      return text;
    }

    const s = text.replace(/_/g, ' ').toLowerCase();
    return s[0].toUpperCase() + s.substring(1);
  }
}